<div id="card">
  <div class="card-image pulsate"></div>
  <div class="card-content">
    <div class="title-block pulsate"></div>
    <div class="sub-block sub-block--2 pulsate"></div>
    <div class="sub-block sub-block--3 pulsate"></div>
    <div class="sub-block sub-block--3 pulsate"></div>
    <div class="chips">
      <div class="chip pulsate"></div>
      <div class="chip pulsate"></div>
    </div>
  </div>
</div>
